/**
 * Simple cartoon-style SVG workers for pipeline nodes (CSS-animated, no external assets).
 */
export function CartoonPreflight({ status = 'pending' }) {
  const running = status === 'running';
  return (
    <svg
      viewBox="0 0 64 64"
      className={`gwe-cartoon-svg gwe-cartoon-svg--preflight${running ? ' gwe-cartoon-svg--running' : ''}`}
      aria-hidden
    >
      <title>Preflight checks</title>
      <ellipse cx="38" cy="50" rx="12" ry="10" fill="#7c6bbd" />
      <g className="gwe-cartoon-clipboard">
        <rect x="12" y="18" width="26" height="34" rx="2.5" fill="#f0ebe3" stroke="#9a8f82" strokeWidth="0.85" />
        <rect x="20" y="14" width="10" height="8" rx="1.5" fill="#8a8a96" stroke="#6a6a74" strokeWidth="0.5" />
        <rect x="22" y="16" width="6" height="4" rx="0.5" fill="#a8a8b4" />
        <rect x="16" y="26" width="18" height="2.2" rx="0.5" fill="#c9bfb2" className="gwe-cartoon-pf-row" />
        <rect x="16" y="32" width="14" height="2.2" rx="0.5" fill="#c9bfb2" className="gwe-cartoon-pf-row" />
        <rect x="16" y="38" width="16" height="2.2" rx="0.5" fill="#c9bfb2" className="gwe-cartoon-pf-row" />
        <rect x="16" y="44" width="5" height="5" rx="1" fill="#fff" stroke="#9a8f82" strokeWidth="0.6" />
        <rect x="16" y="51" width="5" height="5" rx="1" fill="#fff" stroke="#9a8f82" strokeWidth="0.6" />
        <path d="M17.2 46.5 L18.8 48.5 L21.5 44.5" fill="none" stroke="#34d399" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" className="gwe-cartoon-pf-check gwe-cartoon-pf-check--1" />
        <path d="M17.2 53.5 L18.8 55.5 L21.5 51.5" fill="none" stroke="#34d399" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" className="gwe-cartoon-pf-check gwe-cartoon-pf-check--2" />
      </g>
      <circle cx="44" cy="22" r="10" fill="#e8b89a" />
      <path d="M35 16 Q44 8 53 16 Q50 12 44 11 Q38 12 35 16" fill="#6b5b95" />
      <circle cx="41" cy="21" r="1.2" fill="#3d3d48" />
      <circle cx="48" cy="21" r="1.2" fill="#3d3d48" />
      <path d="M40 26 Q44 28 49 26" fill="none" stroke="#3d3d48" strokeWidth="1" strokeLinecap="round" />
      <g className="gwe-cartoon-pf-arm">
        <path d="M36 36 Q28 32 22 38" fill="none" stroke="#e8b89a" strokeWidth="5" strokeLinecap="round" />
      </g>
      <g className="gwe-cartoon-pf-mag">
        <circle cx="52" cy="40" r="7" fill="none" stroke="#a78bfa" strokeWidth="2.5" opacity="0.95" />
        <circle cx="52" cy="40" r="4.5" fill="rgba(167, 139, 250, 0.12)" />
        <line x1="56.5" y1="44.5" x2="60" y2="50" stroke="#8b7fd9" strokeWidth="2.5" strokeLinecap="round" />
      </g>
      <ellipse cx="54" cy="34" rx="4" ry="3.5" fill="#e8b89a" />
    </svg>
  );
}

export function CartoonExecuteLive({ status = 'pending' }) {
  const running = status === 'running';
  return (
    <svg
      viewBox="0 0 64 64"
      className={`gwe-cartoon-svg gwe-cartoon-svg--execute${running ? ' gwe-cartoon-svg--running' : ''}`}
      aria-hidden
    >
      <title>Live execution</title>
      <rect x="6" y="50" width="52" height="5" rx="2" fill="#45454f" />
      <path d="M46 50 L48 34 L52 34 L50 50 Z" fill="#3a3a44" />
      <ellipse cx="34" cy="40" rx="11" ry="9" fill="#7c6bbd" />
      <ellipse cx="38" cy="49" rx="6" ry="3" fill="#5a4d9e" opacity="0.9" />
      <path d="M20 50 L24 42 L42 42 L46 50 Z" fill="#35353f" />
      <rect x="23" y="26" width="20" height="14" rx="1.5" className="gwe-cartoon-screen gwe-cartoon-screen--live" fill="#1a2f4a" stroke="rgba(94, 234, 212, 0.6)" strokeWidth="0.75" />
      <g className="gwe-cartoon-code-lines" opacity="0.9">
        <rect x="26" y="29" width="10" height="1.2" rx="0.4" fill="#5eead4" />
        <rect x="26" y="32" width="14" height="1.2" rx="0.4" fill="#a78bfa" />
        <rect x="26" y="35" width="8" height="1.2" rx="0.4" fill="#5eead4" />
      </g>
      <circle cx="34" cy="20" r="9.5" fill="#e8b89a" />
      <path d="M25 16 Q34 9 43 16 Q40 12 34 12 Q28 12 25 16" fill="#6b5b95" />
      <circle cx="30" cy="20" r="1.2" fill="#3d3d48" />
      <circle cx="38" cy="20" r="1.2" fill="#3d3d48" />
      <path d="M30 24 Q34 27 38 24" fill="none" stroke="#3d3d48" strokeWidth="1" strokeLinecap="round" />
      <g className="gwe-cartoon-hands-typing">
        <ellipse cx="22" cy="40" rx="5" ry="4" fill="#e8b89a" className="gwe-cartoon-hand gwe-cartoon-hand--live-l" />
        <ellipse cx="46" cy="40" rx="5" ry="4" fill="#e8b89a" className="gwe-cartoon-hand gwe-cartoon-hand--live-r" />
      </g>
    </svg>
  );
}

export function CartoonGenerateScript({ status = 'pending' }) {
  const running = status === 'running';
  return (
    <svg
      viewBox="0 0 64 64"
      className={`gwe-cartoon-svg gwe-cartoon-svg--script${running ? ' gwe-cartoon-svg--running' : ''}`}
      aria-hidden
    >
      <title>Generate script</title>
      <ellipse cx="30" cy="54" rx="13" ry="9" fill="#7c6bbd" />
      <circle cx="48" cy="22" r="9.5" fill="#e8b89a" />
      <path d="M40 15 Q48 9 56 15 Q53 12 48 12 Q43 12 40 15" fill="#6b5b95" />
      <circle cx="45" cy="21" r="1.1" fill="#3d3d48" />
      <circle cx="51" cy="21" r="1.1" fill="#3d3d48" />
      <path d="M45 25 Q48 27 51 25" fill="none" stroke="#3d3d48" strokeWidth="0.9" strokeLinecap="round" />
      <rect x="14" y="28" width="30" height="32" rx="2" fill="#f5f0e6" stroke="#c4b8a8" strokeWidth="0.75" className="gwe-cartoon-paper" />
      <path d="M36 28 L44 28 L44 36 Z" fill="#e8dfd0" stroke="#c4b8a8" strokeWidth="0.5" />
      <g className="gwe-cartoon-script-lines">
        <rect x="18" y="34" width="20" height="2" rx="0.5" fill="#8a7b6c" className="gwe-cartoon-line gwe-cartoon-line--1" />
        <rect x="18" y="39" width="16" height="2" rx="0.5" fill="#8a7b6c" className="gwe-cartoon-line gwe-cartoon-line--2" />
        <rect x="18" y="44" width="22" height="2" rx="0.5" fill="#8a7b6c" className="gwe-cartoon-line gwe-cartoon-line--3" />
        <rect x="18" y="49" width="14" height="2" rx="0.5" fill="#8a7b6c" className="gwe-cartoon-line gwe-cartoon-line--4" />
      </g>
      <rect x="8" y="56" width="48" height="4" rx="1.5" fill="#45454f" />
      <g className="gwe-cartoon-scribe-arm">
        <path d="M42 34 Q34 40 24 38" fill="none" stroke="#e8b89a" strokeWidth="4.5" strokeLinecap="round" />
        <line x1="22" y1="37" x2="17" y2="32" stroke="#2d2d36" strokeWidth="1.6" strokeLinecap="round" className="gwe-cartoon-pen-body" />
        <polygon points="16,31 18.5,29.5 19,32" fill="#c94c4c" />
      </g>
    </svg>
  );
}
